import { useCallback } from 'react';
import * as Sentry from '@sentry/react';

export const useSentryReplay = () => {
  const startRecording = useCallback(() => {
    const replay = Sentry.getReplay();

    if (replay) {
      replay.start();
      console.log('Sentry Replay started manually.');
    } else {
      console.warn('Sentry Replay integration not found.');
    }
  }, []);

  const stopRecording = useCallback(() => {
    const replay = Sentry.getReplay();

    if (replay) {
      replay.stop();
      console.log('Sentry Replay stopped manually.');
    }
  }, []);

  return { startRecording, stopRecording };
};
